<script lang="ts" context="module">
  export type Tab = {
    name: string;
    textColor?: string;
    hidden?: boolean;
    // biome-ignore lint/suspicious/noExplicitAny: TODO: Fix this missing type
    icon?: any;
    href?: string;
  };
</script>

<script lang="ts">
  import TriangleCornerIcon from '$icons/TriangleCornerIcon.svelte';

  export let tabs: Tab[] = [];
  export let selectedTab = 0;
  export let stretch = false;
  export let onChange: ((tab: Tab) => void) | undefined = undefined;

  function handleTabChange(index: number) {
    selectedTab = index;
    onChange?.(tabs[index]);
  }
</script>

<div
  class="gap-x-2xs bg-gray-dark-0 flex items-center {stretch
    ? 'justify-between'
    : 'justify-start'} p-[3px] {$$props.class}"
>
  {#if tabs?.length > 0}
    {#each tabs as tab, i}
      {#if !tab.hidden}
        {@const selected = selectedTab == i}
        {#if tab.href}
          <a
            href={tab.href}
            class:selected
            class="gap-x-sm px-lg font-architekt text-gray-dark-12 relative flex h-10 items-center {stretch
              ? 'flex-1 justify-center'
              : ''} text-base font-normal leading-6"
            on:click={() => handleTabChange(i)}
          >
            <div class="triangles absolute inset-0 border-none bg-transparent">
              <TriangleCornerIcon class="text-gray-dark-0 absolute right-0 top-0" />
              <TriangleCornerIcon class="text-gray-dark-0 absolute bottom-0 right-0 rotate-90" />
              <TriangleCornerIcon class="text-gray-dark-0 absolute bottom-0 left-0 rotate-180" />
              <TriangleCornerIcon class="text-gray-dark-0 absolute left-0 top-0 -rotate-90" />
            </div>
            {#if tab.icon}
              <svelte:component this={tab.icon} />
            {/if}
            <span class={tab.textColor ? `text-${tab.textColor}` : 'text-gray-dark-12'}
              >{tab.name}</span
            >
          </a>
        {:else}
          <button
            class:selected
            class="gap-x-sm px-lg font-architekt text-gray-dark-12 relative flex h-10 items-center {stretch
              ? 'flex-1 justify-center'
              : ''} text-base font-normal leading-6"
            on:click={() => (selectedTab = i)}
          >
            <div class="triangles absolute inset-0 border-none bg-transparent">
              <TriangleCornerIcon class="text-gray-dark-0 absolute right-0 top-0" />
              <TriangleCornerIcon class="text-gray-dark-0 absolute bottom-0 right-0 rotate-90" />
              <TriangleCornerIcon class="text-gray-dark-0 absolute bottom-0 left-0 rotate-180" />
              <TriangleCornerIcon class="text-gray-dark-0 absolute left-0 top-0 -rotate-90" />
            </div>
            {#if tab.icon}
              <svelte:component this={tab.icon} />
            {/if}
            <span class={tab.textColor ? `text-${tab.textColor}` : 'text-gray-dark-12'}
              >{tab.name}</span
            >
          </button>
        {/if}
      {/if}
    {/each}
  {/if}
</div>

<style lang="postcss">
  button:hover {
    @apply bg-gray-dark-2;
  }
  .selected {
    @apply bg-gray-dark-3;
  }

  button:focus {
    @apply border-mint-dark-8 ring-mint-dark-4 rounded border ring-[3px];
  }
  button:focus > .triangles {
    @apply hidden;
  }
</style>
